var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.73 1a2.45 2.45 0 0 0-1.64-1 .3.3 0 0 0-.09.64 1.36 1.36 0 0 1 .09 2.68 1.42 1.42 0 0 1-1.8-1.75 1.51 1.51 0 0 1 .35-.6.35.35 0 0 0-.47-.51c-1.81 1.6-.45 4.41 2.14 4A2.19 2.19 0 0 0 22.73 1Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.74 22.63c-.12.46-.6.5-1.08.42a.94.94 0 0 1-.68-.43c-.62-.92.9-2 1.68-1a.34.34 0 0 0 .56-.4 1.79 1.79 0 0 0-1.73-.85 1.88 1.88 0 0 0-1.44 2.95c.9 1.16 3.2.85 3.28-.58a.3.3 0 1 0-.59-.11Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23 1.78A.3.3 0 0 0 5 2.1a1.5 1.5 0 0 1-1.84 1.48 1.36 1.36 0 0 1-1-2 1.52 1.52 0 0 1 2.39-.16.35.35 0 0 0 .45.14c.46-.19.07-.81-.34-1.12a2.52 2.52 0 0 0-3.35.48A2.32 2.32 0 0 0 3 4.62c2.47.18 3.07-2.9 2.23-2.84Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34 4.63c-1.1-.76-1.43.36-.89.82.16.16 1.68 1.34 1.91 1.47.49.23.94-.29.57-.86a8.21 8.21 0 0 0-1.59-1.43Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.39 19.77a.34.34 0 1 0 .68 0 4.81 4.81 0 0 0 .1-2.13c-.12-.33-.66-.3-.73 0a3.7 3.7 0 0 0-.05 2.13Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 7.27a6.67 6.67 0 0 0-8.5-.47 3.3 3.3 0 0 0-.73.73A5.43 5.43 0 0 0 6.73 13a4 4 0 0 0 1.6 2.5.3.3 0 0 0 .33-.5c-1.4-1-2-4.26-.46-6.32a5.3 5.3 0 0 1 8.21-.42c2.59 3 1.05 7.6-3.51 8.13a6 6 0 0 1-2.49-.18.35.35 0 0 0-.22.66c6.06 2.01 11.43-4.77 6.91-9.6Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.51 4.91a.34.34 0 0 0-.47-.5A7.34 7.34 0 0 0 17.22 6c-.54.63-.12 1.2.54.74a6.61 6.61 0 0 0 1.75-1.83Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.55 9.24a.21.21 0 0 0-.09.19c0 .07-.23 3-.23 3.08 0 1 .47 1.2 1.38 1.37-.2.52.2 1.08.4 1.08s.49-.73.34-1A4.29 4.29 0 0 0 13 14c0 .28.07 1.08.41 1.08s.58-.8.38-1.22A1.51 1.51 0 0 0 15 12.5a1.36 1.36 0 0 0-.66-1.31c.76-.58.73-1.93-.86-2.19.24-.67 0-.62 0-1.09a.24.24 0 0 0-.24-.24c-.13 0-.19.07-.29.16a2.41 2.41 0 0 0-.23.63 1 1 0 0 0 0 .49c-.74 0-.77.07-.72 0a1.28 1.28 0 0 0 .09-.51c-.11-.86-.2-.72-.32-.79s-.5.45-.57.75a.94.94 0 0 0 0 .29.64.64 0 0 0 .05.15 2.2 2.2 0 0 0 0 .27c-.72.12-.59.05-.7.13Zm3.33 3.6a4 4 0 0 1-2.83.14c-.26-.23-.19-1-.15-1.41.54.09 2.59 0 3.06.41a.51.51 0 0 1-.08.86Zm-2.06-3.27c.59 0 2.23-.06 2.3.53s-.71.72-1.32.73c-2.05-.22-1.8.17-1.8-.23l0-.87c.17-.05-.23-.01.82-.16Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialTechnology);
export default __webpack_public_path__ + "static/media/financial-technology.45d777e832718f13774831313399ede8.svg";
export { ForwardRef as ReactComponent };